/**
 * MSW Upsell Guard
 * Ensures the $15 extra strap (extra-hook-strap-1) is only in the cart
 * when a Cap + Strap combo (msw-cap-strap) is also present.
 * Extra strap quantity is capped to the total combo quantity.
 */
(function() {
  'use strict';

  var COMBO_HANDLE = 'msw-cap-strap';
  var UPSELL_HANDLE = 'extra-hook-strap-1';
  var busy = false;

  function checkCart() {
    if (busy) return;
    busy = true;

    fetch('/cart.js')
      .then(function(res) { return res.json(); })
      .then(function(cart) {
        var items = cart.items || [];
        var comboQty = 0;
        var upsellItems = [];

        for (var i = 0; i < items.length; i++) {
          if (items[i].handle === COMBO_HANDLE) comboQty += items[i].quantity;
          if (items[i].handle === UPSELL_HANDLE) upsellItems.push({ key: items[i].key, qty: items[i].quantity });
        }

        var totalUpsellQty = 0;
        for (var j = 0; j < upsellItems.length; j++) {
          totalUpsellQty += upsellItems[j].qty;
        }

        if (totalUpsellQty > comboQty) {
          var excess = totalUpsellQty - comboQty;
          var updates = {};

          // Reduce from last line items first
          for (var k = upsellItems.length - 1; k >= 0 && excess > 0; k--) {
            var item = upsellItems[k];
            if (item.qty <= excess) {
              updates[item.key] = 0;
              excess -= item.qty;
            } else {
              updates[item.key] = item.qty - excess;
              excess = 0;
            }
          }

          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
          .then(function() {
            busy = false;
            doRefresh();
          })
          .catch(function() { busy = false; });
        } else {
          busy = false;
        }
      })
      .catch(function() { busy = false; });
  }

  function doRefresh() {
    if (typeof window.mswCartRefresh === 'function') {
      window.mswCartRefresh();
    }
  }

  window.mswCheckUpsell = checkCart;

  setTimeout(checkCart, 1500);
})();
